import { useEffect, useCallback } from "react";
import { X } from "lucide-react";
import "./SlidePanel.scss";

const SlidePanel = ({ isOpen, onClose, title, children, width = "60%" }) => {
  const handleBackdropClick = useCallback(
    (e) => {
      if (e.target.classList.contains("slide_panel_backdrop")) {
        onClose();
      }
    },
    [onClose]
  );

  const handleEscKey = useCallback(
    (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("keydown", handleEscKey);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", handleEscKey);
      document.body.style.overflow = "";
    };
  }, [isOpen, handleEscKey]);

  if (!isOpen) return null;

  return (
    <div className="slide_panel_backdrop" onClick={handleBackdropClick}>
      <div className="slide_panel" style={{ width }}>
        <div className="slide_panel_header">
          <h3>{title}</h3>
          <button className="close_btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div className="slide_panel_content">{children}</div>
      </div>
    </div>
  );
};

export default SlidePanel;
